import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import React from 'react';
import BrandDy from './BrandDy';
import BrandMt from './BrandMt';

export const IconMT = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BrandMt} {...props} style={{...(props.style || {}) , color:'#000'}} />
);
export const IconDY = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BrandDy} {...props} />
);
